module.exports = __webpack_public_path__ + "assets/img/icon1.1.29ac5c70.svg";